import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "worker-list-table wrapper brg-table" };
import { selectedWorkerListTableHeader as tableHeaders } from '@/constants/workerManagementBulkEdit';
import { computed } from 'vue';
import vuexStore from '@/vuex-store';
import SelectedWorkerListRow from './SelectedWorkerListRow.vue';
const lc = 'views.worker_management_bulk_edit.worker_list_table.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SelectedWorkerListTable',
    setup(__props) {
        const getterSelectedWorkerList = computed(() => vuexStore.getters['workerManagement/workerBulkEdit/getterSelectedWorkerList']);
        return (_ctx, _cache) => {
            const _component_v_data_table = _resolveComponent("v-data-table");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_data_table, {
                    hover: "",
                    "item-key": "hubName",
                    headers: _unref(tableHeaders),
                    items: getterSelectedWorkerList.value,
                    "items-per-page": getterSelectedWorkerList.value.length + 1,
                    "fixed-header": "",
                    "hide-default-footer": "",
                    "no-data-text": _ctx.$t(`${lc}no_data_text`)
                }, {
                    item: _withCtx(({ item }) => [
                        _createVNode(SelectedWorkerListRow, { item: item }, null, 8 /* PROPS */, ["item"])
                    ]),
                    bottom: _withCtx(() => _cache[0] || (_cache[0] = [])),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["headers", "items", "items-per-page", "no-data-text"])
            ]));
        };
    }
});
